<app-spinner></app-spinner>

<div class="mx-auto" style="width: 82%">

  <div class="d-flex flex-row">
    <div class="col-1">
      <a routerLink="/admin/customerform/create/">
        <button type="button" class="btn btn-primary mb-5">Kunde Erstellen</button>
      </a>
    </div>
    <div class="col-11 ms-3">
      <p>
        Archivierte anzeigen
      </p>
      <input type="checkbox" name="" id="checkbox-showarchived" class="checkbox-slider"
             (click)="this.changeShowArchivedStatus($event)">
      <label for="checkbox-showarchived"></label>
    </div>
  </div>

  <table class="table top">
    <thead>
    <tr>
      <th scope="col" class="pointer" (click)="this.sortTablebyColum('uuid')">
        UUID <i *ngIf="this.lastsort === 'uuid'"
                [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
                class="bi"></i>
      </th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('display_name')">
        Anzeigename <i *ngIf="this.lastsort === 'display_name'"
                       [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
                       class="bi"></i>
      </th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('company_name')">
        Firmenname <i *ngIf="this.lastsort === 'company_name'"
                      [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
                      class="bi"></i>
      </th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('zipcode')">
        Postleizahl <i *ngIf="this.lastsort === 'zipcode'"
                       [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
                       class="bi"></i>
      </th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('city')">
        Stadt <i *ngIf="this.lastsort === 'city'"
                 [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
                 class="bi"></i>
      </th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('district')">
        Stadteil <i *ngIf="this.lastsort === 'district'"
                    [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
                    class="bi"></i>
      </th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('street')">
        Straße <i *ngIf="this.lastsort === 'street'"
                  [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
                  class="bi"></i>
      </th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('created_by')">Erstellt durch<i
        *ngIf="this.lastsort === 'created_by'"
        [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
        class="bi"></i>
      </th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('creation_date')">Erstellungsdatum<i
        *ngIf="this.lastsort === 'creation_date'"
        [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
        class="bi"></i></th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('archived')">Archiviert<i
        *ngIf="this.lastsort === 'archived'"
        [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
        class="bi"></i></th>

      <th>Aktionen</th>
    </tr>
    </thead>
    <tbody>
    <tr (click)="Helper.TableSelect($event)" *ngFor="let customer of this.customers | async" id="{{customer.uuid}}">
      <td>{{ customer.uuid }}</td>
      <td>{{ customer.display_name }}</td>
      <td>{{ customer.company_name }}</td>
      <td>{{ customer.zipcode }}</td>
      <td>{{ customer.city }}</td>
      <td>{{ customer.district ? customer.district : "-" }}</td>
      <td>{{ customer.street }}</td>
      <td>{{ customer.created_by_name }}</td>
      <td>{{ Utils.getDateFormated(customer.creation_date) }}</td>
      <td>
        <input type="checkbox" name="" id="checkbox{{customer.uuid}}"
               [disabled]="!PermissionsHelper.hasPermission('staff.customer.edit')"
               (click)="this.changeArchivedStatus($event,customer)" class="checkbox-slider"
               [checked]="customer.archived">
        <label for="checkbox{{customer.uuid}}"></label>
      </td>
      <td>
        <button class="btn btn-primary me-2" [disabled]="!PermissionsHelper.hasPermission('staff.customer.edit') || customer.archived"
                (click)="this.router.navigateByUrl('/admin/customerform/edit/' + customer.uuid)">Kunde Bearbeiten
        </button>
        <button class="btn btn-secondary me-2" [disabled]="!PermissionsHelper.hasPermission('staff.customer.contacts.read')"
                (click)="this.router.navigateByUrl('/admin/contacts/' + customer.uuid)">Ansprechpartner
        </button>
      </td>
    </tr>
    </tbody>
  </table>
  <div *ngIf="(this.customers | async)?.length === 0" class="text-center m-3">
    <p>Aktuell gibt es leider keine Aktiven Kunden</p>
  </div>
</div>
